import React from 'react'
import { motion } from 'framer-motion'
import outcomeIcon from '../../../assets/images/tatvacare/outcome.webp'

const outcomeData = [
  {
    number: '01',
    point: 'Reducing time spent searching for information',
  },
  {
    number: '02',
    point: 'Improving confidence in decision- making',
  },
  {
    number: '03',
    point: 'Delivering reliable insights in seconds',
  },
  {
    number: '04',
    point: 'Creating a seamless bridge between AI and healthcare',
  },
]

const OutcomeImport = () => (
  <section className="w-full bg-purple/20 pt-10">
    <div className="mx-auto w-full max-w-[92%]">
    <div className="flex items-center justify-center gap-3">

<img
  src={outcomeIcon}
  alt="Outcome and Impact icon"
  className="h-8 w-8 shrink-0 md:h-10 md:w-10 lg:h-12 lg:w-12"
/>

<h2 className="font-gilroy-bold text-2xl text-white md:text-4xl lg:text-5xl">
  Outcome & Impact
</h2>

</div>

      <p className="mt-2 text-center font-gilroy-medium text-lg text-white md:mt-5 md:text-xl lg:text-3xl">
        Tattva Care enhances clinical workflows by:
      </p>

      {/* Cards */}
    

<div className="mt-5 grid w-full grid-cols-2 gap-4 md:mt-12 md:gap-6">

  {outcomeData.map((item, index) => (
    <motion.div
      key={item.number}
      initial={{
        opacity: 0,
        scale: 0.65,
      }}
      whileInView={{
        opacity: 1,
        scale: 1,
      }}
      viewport={{
        once: false,
        amount: 0.3,
      }}
      transition={{
        duration: 0.55,
        delay: index * 0.08,
        ease: 'easeOut',
      }}
      className="
        flex
        w-full
        flex-col
        justify-start
        rounded-[15px]
        border
        border-white
        bg-[#ffffff10]
        px-3
        py-4
        text-start

        lg:min-h-[180px]
        lg:px-6
        lg:py-8

        2xl:min-h-[220px]
      "
    >

      <div className="font-gilroy-bold text-3xl text-[#121112] md:text-4xl lg:text-5xl 2xl:text-6xl">
        {item.number}
      </div>

      <p className="font-gilroy-medium text-sm text-white md:mt-2 lg:mt-4 lg:text-xl xl:mt-6 xl:text-2xl 2xl:text-3xl">
        {item.point}
      </p>

    </motion.div>
  ))}

</div>

   
    </div>
  </section>
)

export default OutcomeImport